module.exports = __webpack_public_path__ + "static/media/mulher_r2_c4.69e07d2f.jpg";